import { Mediaclip } from '../../../interfaces/mediaclip';
import { NgForm } from '@angular/forms';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
	selector: 'mediaclip-details-thumbnail',
	templateUrl: './mediaclip-details-thumbnail.component.html',
	styleUrls: ['./mediaclip-details-thumbnail.component.scss']
})


export class MediaclipDetailsThumbnailComponent implements OnInit {
	@Input() form: NgForm;
	@Input()
	get mediaclip() {
		return this._mediaclip;
	}
	set mediaclip(mediaclip) {
		this._mediaclip = mediaclip;
	}

	@Output() mediaclipChange = new EventEmitter();

	asset = '';
	private _mediaclip: Mediaclip;

	ngOnInit() {
		if (this.mediaclip) {
			this.initMediaclip();
		}
	}

	thumbnailsChanged(thumbnails: any[]) {
		this._mediaclip.thumbnails = thumbnails;
		this.mediaclipChange.emit(this._mediaclip);
	}

	initMediaclip() {
		if (!this.mediaclip || !this.mediaclip.assets || !this.mediaclip.assets.length) {
			return '';
		}

		const filteredAssets: any[] = [];

		this.mediaclip.assets.forEach((asset: any) => {
			if (asset.mediatype && asset.mediatype.indexOf('MP4_') !== -1 && asset.mediatype.indexOf('HLS') === -1) {
				filteredAssets.push(asset);
			}
		});
		filteredAssets.sort((a, b) => Number(b.bandwidth - a.bandwidth));

		if (filteredAssets[0]) {
			this.asset = filteredAssets[0].src;
		}
	}
}
